import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=5487f8ce&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5487f8ce')) {
      api.createRecord('5487f8ce', component.options)
    } else {
      api.reload('5487f8ce', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=5487f8ce&", function () {
      api.rerender('5487f8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29Vr5jAPvAp2W/JS/IncreaseNumber.vue"
export default component.exports